import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ResponsePersonalData } from '../../../services/api/models/response/responsePersonalData';

export interface ProfilePageState {
  isShowEditModal?: boolean;
  userData?: ResponsePersonalData;
  isShowModalMission?: boolean;
  isShowModalFollowList?: boolean;
  isFollowing?: boolean;
}

const initState: ProfilePageState = {};

const profilePageSlice = createSlice({
  name: 'profile-page',
  initialState: initState,
  reducers: {
    reset: () => {
      return initState;
    },
    updateUserData: (state, action: PayloadAction<ResponsePersonalData>) => {
      state.userData = action.payload;
    },
    toggleEditModal: (state, action: PayloadAction<boolean>) => {
      state.isShowEditModal = action.payload;
    },
    toggleModalMission: (state, action: PayloadAction<boolean>) => {
      state.isShowModalMission = action.payload;
    },
    toggleModalFollowList: (state, action: PayloadAction<boolean>) => {
      state.isShowModalFollowList = action.payload;
    },
    updateFollowing: (state, action: PayloadAction<boolean>) => {
      state.isFollowing = action.payload;
    },
  },
});

export const {
  reset,
  toggleEditModal,
  updateUserData,
  toggleModalMission,
  toggleModalFollowList,
  updateFollowing,
} = profilePageSlice.actions;
export const ProfilePageReducer = profilePageSlice.reducer;
